<ng-container *transloco="let t; prefix: 'compareAgent.no-agents'">
  <h1>{{ t('title') }}</h1>
  <p>{{ t('blurb') }}</p>

  @if (!isLocation()) {
    <a mat-stroked-button routerLink="/search" color="primary"
      ><rma-icon glyph="search" /><span>{{ t('button') }}</span></a
    >
  }
</ng-container>
